import { useRef, useLayoutEffect } from "react";
import debounce from "lodash/debounce";

function getScrollElement(element) {
  const target = element?.current || document.body;
  const position = target.getBoundingClientRect();

  return {
    x: position.left,
    y: position.top,
    bottom: position.bottom,
    height: position.height,
  };
}

export function useScrollElement(effect, element) {
  const position = useRef(getScrollElement(element));

  useLayoutEffect(() => {
    const callback = debounce((val) => {
      const handleEffect = () => {
        const currPos = getScrollElement(element);
        effect({ prevPos: position.current, currPos });
        position.current = currPos;
      };

      handleEffect();
    }, 250);

    const handleScroll = () => {
      callback();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [effect, element]);
}
